import { EnumJoinStatus, EnumMoreOptions } from '@xt/client/enums/kindred-spirit'

export const dataSource_tonghao = [
  { key: '0', title: '关注' },
  { key: '1', title: '发现' },
  { key: '2', title: '笔墨点亮生活' },
  { key: '3', title: '好作业' },
  { key: '4', title: '学习感悟' },
  { key: '5', title: '回后山' },
  { key: '6', title: '小食光' },
  { key: '7', title: '暄桐雅集' },
  { key: '8', title: '桐学雅会' },
  { key: '9', title: '桐学作品' }
]

export const dataSource_tonghaoV2 = [
  { key: '0', title: '关注' },
  { key: '1', title: '发现' },
  { key: '10', title: '桐学会' },
  { key: '2', title: '笔墨点亮生活' },
  { key: '3', title: '好作业' },
  { key: '4', title: '学习感悟' },
  { key: '5', title: '回后山' },
  { key: '6', title: '小食光' },
  { key: '7', title: '暄桐雅集' },
  { key: '8', title: '桐学雅会' },
  { key: '9', title: '桐学作品' }
]

export const dataSource_topicManagerFilter = [
  { key: '', label: '全部' },
  { key: EnumJoinStatus.Join, label: '待入群' },
  { key: EnumJoinStatus.Exit, label: '待退出' }
]

export const dataSource_topicMoreOpions = [
  {
    key: EnumMoreOptions.List,
    label: '更多分桐'
  },
  {
    key: EnumMoreOptions.Manager,
    label: '分桐管理'
  },
  {
    key: EnumMoreOptions.Exit,
    label: '退出分桐'
  }
]

export const dataSource_hide_store_key: {
  hideCitiesStoreKey: string
  hideLocationTipStoreKey: string
  hideImproveModalStoreKey: string
} = {
  hideCitiesStoreKey: 'hide-recommend-cities',
  hideLocationTipStoreKey: 'hide-location-tip',
  hideImproveModalStoreKey: 'hide-improve-tip'
}
